export enum MediaRouteNameEnum {
	list = "media.list",
	detail = "media.detail",
	upload = "media.upload",

}
